import React from 'react';
import classNames from 'classnames';
import { useAddressesContext } from '../../AddressesContext';
import AddressSelectItem from '../../../AddressSelectItem';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../Button';
import './AddressList.scss';

const AddressList = () => {
  const {
    addresses,
    selectedAddress,
    onAddressSelect,
    handleEditAddress,
    handleAddAddress,
    handleSetPrimaryAddress,
    showContinueButton,
    onContinue,
    continueButtonText,
    isUpdatingPriority,
    selectionEnabled,
    userData,
    designSystemForms,
  } = useAddressesContext();

  const isSelectedAddress = (address) => {
    if (!selectedAddress || !address) return false;
    return selectedAddress.uid === address.uid;
  };

  const renderAddressItem = (address, onAddClick, onEditClick) => {
    if (address) {
      return (
        <div
          key={address.uid}
          className="AddressList__address-item"
        >
          <div className="AddressList__address-content">
            <AddressSelectItem
              address={{
                firstName: userData?.firstName || '',
                lastName: userData?.lastName || '',
                ...address,
              }}
              selectionEnabled={selectionEnabled}
              isSelected={isSelectedAddress(address)}
              onSelect={() => onAddressSelect?.(address)}
              onEdit={() => onEditClick(address)}
              onSetAsPrimary={() => handleSetPrimaryAddress(address)}
              alertMessage={!address?.firstName || !address?.lastName
                ? 'Add a delivery name so you can use this address.'
                : null}
              isUpdating={isUpdatingPriority}
            />
          </div>
        </div>
      );
    }

    return (
      <div
        className="AddressList__placeholder-item"
        onClick={onAddClick}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onAddClick();
          }
        }}
      >
        <div className="AddressList__placeholder-content">
          <div className="AddressList__placeholder-text">
            {`${addresses?.length > 0 ? 'Different address? ' : ''}You can save up to 2 addresses.`}
          </div>
          <div className="AddressList__placeholder-cta">
            Add a new address
          </div>
        </div>
      </div>
    );
  };

  const firstAddress = addresses[0];
  const secondAddress = addresses[1];

  return (
    <div className="AddressList">
      <div className="AddressList__header">
        <h2>{selectionEnabled ? 'Select Your Delivery Address' : 'Delivery Addresses'}</h2>
      </div>

      <div className="AddressList__addresses">
        {renderAddressItem(
          firstAddress,
          handleAddAddress,
          handleEditAddress,
        )}

        {renderAddressItem(
          secondAddress,
          !secondAddress ? handleAddAddress : null,
          secondAddress ? handleEditAddress : null,
        )}
      </div>

      {(showContinueButton && selectedAddress) && (
        <div className="AddressList__continue">
          <Button
            type={BUTTON_TYPE.QUATERNARY}
            size={BUTTON_SIZE.LARGE}
            onClick={onContinue}
            disabled={isUpdatingPriority ||
              !selectedAddress?.firstName || !selectedAddress?.lastName}
            className={classNames({
              'AddressList__continue--disabled': !selectedAddress?.firstName || !selectedAddress?.lastName,
              'ds20Btn ds20Btn--primary ds20Btn--block': designSystemForms,
            })}
          >
            {isUpdatingPriority ? 'Updating...' : continueButtonText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default AddressList;
